var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGasPump = function SvgIconGasPump(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.75 5.25V9.5H18a2.5 2.5 0 0 1 2.5 2.5v3.75a.5.5 0 0 0 .5.5h.375a.5.5 0 0 0 .5-.5V8.121a.5.5 0 0 0-.148-.355l-1.81-1.809a1 1 0 0 1 1.415-1.414l1.81 1.81c.467.468.73 1.1.733 1.761v7.636a2.5 2.5 0 0 1-2.5 2.5H21a2.5 2.5 0 0 1-2.5-2.5V12a.5.5 0 0 0-.5-.5h-1.25v7.75H18a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h1.25v-14a2.5 2.5 0 0 1 2.5-2.5h7.5a2.5 2.5 0 0 1 2.5 2.5M6.396 4.896a.5.5 0 0 1 .354-.146h7.5a.5.5 0 0 1 .5.5v14h-8.5v-14a.5.5 0 0 1 .146-.354",
    clipRule: "evenodd"
  }))));
};
export default SvgIconGasPump;